/**
 * Shared by the mint route, the redemption provider, and the client that
 * derives the PKCE challenge. Deliberately Web Crypto rather than
 * `node:crypto`: the verifier is hashed in the WebView and re-hashed on the
 * server, and the two must agree byte for byte. One implementation removes
 * the chance of them drifting on encoding.
 */

function toBase64Url(bytes: Uint8Array): string {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/** base64url(sha256(input)) — 43 characters, unpadded. */
export async function sha256Base64Url(input: string): Promise<string> {
  const digest = await globalThis.crypto.subtle.digest("SHA-256", new TextEncoder().encode(input));
  return toBase64Url(new Uint8Array(digest));
}

/** 32 bytes of CSPRNG output, base64url encoded. Used for codes and verifiers. */
export function generateCode(): string {
  const bytes = new Uint8Array(32);
  globalThis.crypto.getRandomValues(bytes);
  return toBase64Url(bytes);
}
